import { render, staticRenderFns } from "./ViewAllBranchOrWarehousesModal.vue?vue&type=template&id=592f28ba&"
import script from "./ViewAllBranchOrWarehousesModal.vue?vue&type=script&lang=js&"
export * from "./ViewAllBranchOrWarehousesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports